<template>
    <span class="vueContainer">
        <div class="filter-container">
            <div class="search-row">
                <input type="text" v-model="searchQuery" placeholder="Search..." @keyup.enter="applySearch">
                <button @click="applySearch">Search</button>
            </div>
            <div class="filters-row" v-click-outside="closeDropdowns">
                <div class="filter-column" v-for="(filter, index) in filters" :key="index">
                    <label class="filter-title">{{ filter.title }}</label>
                    <div ref="toggleButton" @click="toggleDropdown(index)" class="dropdown-button">
                        <span class="NofFilter" v-show="selectedFiltersActive[index] > 0">{{ selectedFiltersActive[index]
                        }}</span> Select filters...
                        <span class="arrow">&#9660;</span>
                    </div>
                    <div class="checkbox-dropdown" :class="{ 'show': filter.show }">
                        <div class="checkbox-option" v-for="option in filter.options" :key="option.name">
                            <input type="checkbox" :id="option.name" :value="option.name" v-model="option.checked"
                                @change="applySearch">
                            <label :for="option.name">{{ option.name }}</label>
                        </div>
                    </div>
                </div>
                <div class="resetFilterButtonContainer">
                    <div class="resetFilterButon" @click="clearFilters">Clear Filters</div>
                </div>
            </div>

            <!--             <button @click="applySearch" class="apply-button">Apply filter</button>
 -->
        </div>

        <!-- Results Section -->
        <div class="results-container">
            <a class="result-card" v-for="(post, index) in visibleResults" :key="post.id" :href="post.link"
                :class="getCardClass(index)">
                <div class="result-icon" :class="getIconClass(index)">
                    <img :src="getIconSrc(post)" alt="Icon" class="imgIconResult" />
                </div>
                <div class="result-summary" v-html="post.acf['post-excerpt']"></div>
                <div class="result-title" :class="getTitleClass(index)" v-html="post.title.rendered"></div>
                <div class="hover-overlay" :class="getHoverClass(index)">
                    <div class="hover-title" v-html="post.title.rendered"></div>
                </div>
            </a>
            <div v-if="!firstLoadDone" class="loaderContainer">
                <div class="loader"></div>
            </div>
            <div v-else-if="visibleResults.length < 1">
                No results found based on your filter selection
            </div>
        </div>

        <div v-if="firstLoadDone && filteredResults.length > visibleResults.length && visibleResults.length > 1"
            class="load-more-controls">
            <button @click="loadMoreResults">Load More</button>
        </div>

    </span>
</template>
  
<script>
import database from './databaseResources'

export default {
    data() {
        return {
            firstLoadDone: false,

            visibleResults: [],
            filteredResults: [],

            allPosts: [],
            imageUrls: {},
            defaultIconSrc: 'https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-25.png',
            imageReference: {
                "2509": "https://victoriadivision.ca/wp-content/uploads/2024/01/homepage-Support-for-you-2.png",
                "2528": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-15.png",
                "1571": "https://victoriadivision.ca/wp-content/uploads/2023/12/1-Campaign.png",
                "2537": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-24.png",
                "2538": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-25.png",
                "2534": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-21.png",
                "2532": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-19.png",
                "1576": "https://victoriadivision.ca/wp-content/uploads/2023/12/7-Tools.png",
                "1573": "https://victoriadivision.ca/wp-content/uploads/2023/12/3-Guide.png",
                "2515": "https://victoriadivision.ca/wp-content/uploads/2024/01/News-hub-story-to-tell.png",
                "1574": "https://victoriadivision.ca/wp-content/uploads/2023/12/4-Guide.png",

                "2536": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-23.png",
                "2526": "https://victoriadivision.ca/wp-content/uploads/2024/01/Programs-and-services-13.png",

            },

            fullDatabase: [],


            selectedFiltersActive: [0, 0, 0, 0],

            currentPage: 1,
            itemsPerPage: 9,

            showLoadMoreButton: true,

            searchQuery: '',
            filtersOld: [
                {
                    title: 'Career Stage',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { "name": "Grow Your Practice", "ids": [162] },
                        { "name": "Practice Management", "ids": [70] },
                        { "name": "Retirement", "ids": [72] }]
                },
                {
                    title: 'Programs & Committees',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { "name": "AGM", "ids": [166, 167, 179] },
                        { "name": "Clinic Grants", "ids": [187, 186, 185] },
                        { "name": "Interprofessional Teams", "ids": [205, 153, 152] },
                        { "name": "Mental Health", "ids": [198, 119, 117] },
                        { "name": "Community Practice", "ids": [196] },
                        { "name": "Continuity of Care", "ids": [199] },
                        { "name": "FP Service Contracts", "ids": [155, 154] },
                        { "name": "Long Term Care", "ids": [180] },
                        { "name": "MOA Program", "ids": [190] },
                        { "name": "NP Service Contracts", "ids": [149, 150] }]
                },
                {
                    title: 'Content Type',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { "name": "Announcements", "ids": [126] },
                        { "name": "Business Tools", "ids": [163] },
                        { "name": "Contract Template", "ids": [151] },
                        { "name": "For Patients", "ids": [73] },
                        { "name": "Form Letters", "ids": [127] },
                        { "name": "Guidelines", "ids": [124] },
                        { "name": "How-To", "ids": [128] },
                        { "name": "Reports & Data", "ids": [125] }]
                },
                {
                    title: 'Tags',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { "name": "JEDI", "ids": [173, 195] },
                        { "name": "Physician Wellness", "ids": [172, 129, 165] },
                        { "name": "Primary Care Crisis", "ids": [156, 170, 184] },
                        { "name": "CBT", "ids": [118, 79] },
                        { "name": "COVID-19", "ids": [74] },
                        { "name": "EASI Maternity Care", "ids": [148, 91] },
                        { "name": "Flu Vaccine", "ids": [169, 168] },
                        { "name": "Funding", "ids": [175] },
                        { "name": "Monkeypox", "ids": [174] }
                    ]
                },
            ],

            filtersDEV: [
                {
                    title: 'Career Stage',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { "name": "New Doctors", "ids": [218] },
                        { "name": "Retiring Doctors", "ids": [220] },
                        { "name": "Running your Practice", "ids": [219] }
                    ]
                },
                {
                    title: 'Programs & Committees',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { "name": "Clinic Business Solutions", "ids": [223] },
                        { "name": "Clinical Resources & Guidelines", "ids": [229] },
                        { "name": "Continuity of Care", "ids": [228] },
                        { "name": "Long Term Care", "ids": [225] },
                        { "name": "Maternity Care", "ids": [230] },
                        { "name": "Mental Health & Substance Use", "ids": [221] },
                        { "name": "Patient Care", "ids": [224] },
                        { "name": "Patient Resources", "ids": [227] },
                        { "name": "Recruitment & Retention", "ids": [222] },
                        { "name": "Vancouver Division Membership", "ids": [226] }
                    ]
                },
                {
                    title: 'Content Type',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { "name": "Event", "ids": [236] },
                        { "name": "Guide", "ids": [233] },
                        { "name": "Initiative", "ids": [231] },
                        { "name": "News", "ids": [234] },
                        { "name": "Report", "ids": [235] },
                        { "name": "Tool", "ids": [232] }
                    ]
                },
                {
                    title: 'Tags',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { "name": "AGM", "ids": [249] },
                        { "name": "CBT", "ids": [250] },
                        { "name": "Children & Youth", "ids": [251] },
                        { "name": "COVID-19", "ids": [252] },
                        { "name": "Fast Facts", "ids": [253] },
                        { "name": "Flu Vaccine", "ids": [254] },
                        { "name": "Funding & Grants", "ids": [255] },
                        { "name": "IPT", "ids": [256] },
                        { "name": "JEDI", "ids": [257] },
                        { "name": "Legal Support", "ids": [258] },
                        { "name": "Physician Wellness", "ids": [259] },
                        { "name": "Primary Care Crisis", "ids": [260] }
                    ]
                }
            ],


            ImgIDsObj: {},

            filters: [
                {
                    title: 'Career Stage',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { name: "Late career/Retiring", ids: [41] },
                        { name: "New to Practice", ids: [42] },
                        { name: "Mid career/Practicing", ids: [38] },
                        { name: "Students & Residents", ids: [325] }
                    ]
                },
                {
                    title: 'Topic Areas',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { name: "Care Transitions", ids: [115] },//
                        { name: "Clinic/Business Resources", ids: [44] },//
                        { name: "Membership", ids: [114] },//
                        { name: "Patient Resources", ids: [52] },//
                        { name: "Primary Care Network", ids: [113] },//
                        { name: "Recruitment & Retention", ids: [53] },//
                        { name: "Long-term Care Initiative", ids: [327] },//
                        { name: "Patient Medical Home Development", ids: [326] },//

                    ]
                },
                {
                    title: 'Content Type',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { name: "Events & Webinars", ids: [336] },
                        { name: "Guide", ids: [55] },
                        { name: "News", ids: [328] },
                        { name: "Initiative", ids: [56] },
                        { name: "Report", ids: [58] },
                        { name: "Tool", ids: [59] }
                    ]
                },
                {
                    title: 'Tags',
                    show: false,
                    selectedFiltersActive: '',
                    options: [
                        { name: "Care of the Elderly", ids: [117] },//
                        { name: "Collaborative Services Committee", ids: [124] },//
                        { name: "Cultural Safety & Indigenous Health", ids: [119] },//
                        { name: "Long Term Care", ids: [120] },//
                        { name: "Member Updates", ids: [123] },//
                        { name: "Member Wellness", ids: [121] },//
                        { name: "Membership Information", ids: [122] },//
                        { name: "Mental Health & Substance Use", ids: [118] },//
                        { name: "Tools for Physicians & Clinics", ids: [125] },//
                        { name: "Urban Locum Program", ids: [116] },//
                        { name: "Events", ids: [330] },//
                        { name: "MOAs", ids: [329] },//
                    ]
                }
            ],
        };
    },
    //https://van-division.yarko.dev/resources/
    //https://van-division.yarko.dev/wp-admin/edit-tags.php?taxonomy=career_stage&post_type=event
    //https://van-division.yarko.dev/wp-admin/edit-tags.php?taxonomy=programs_committees&post_type=event
    //https://van-division.yarko.dev/wp-admin/edit-tags.php?taxonomy=content_type&post_type=event
    //https://van-division.yarko.dev/wp-admin/edit-tags.php?taxonomy=tags&post_type=event
    methods: {
        toggleDropdown(index) {
            this.filters.forEach((filter, i) => {
                if (i !== index) filter.show = false;
            });
            this.filters[index].show = !this.filters[index].show;
        },
        applySearch() {
            this.currentPage = 1
            this.applyCompositeFilter();
        },

        goToPreviousPage() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.logPageAndScroll();
            }
        },
        goToNextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage += 1;
                this.logPageAndScroll();
            }
        },
        logPageAndScroll() {
            const filtersContainer = this.$el.querySelector('.filter-container');
            if (filtersContainer) {
                filtersContainer.scrollIntoView({ behavior: 'smooth' });
            }
        },

        loadMoreResults() {
            // console.log('laod more')
            //  console.log(this.filteredResults)
            const totalVisible = this.visibleResults.length;
            const nextItems = this.filteredResults.slice(totalVisible, totalVisible + this.itemsPerPage);
            this.visibleResults = [...this.visibleResults, ...nextItems];
            //  console.log('visible', this.visibleResults.length)
            //  console.log("total", this.filteredPosts)
        },



        applyCompositeFilter() {
            // console.log(this.filters)
            const selectedFilters = this.filters.map(filter => ({
                title: filter.title,
                selected: filter.options.filter(option => option.checked).map(option => ({ name: option.name, ids: option.ids }))
            }));
            //  console.log(selectedFilters);

            let dropdownActiveFilters = [];

            let filteredPosts = [];

            selectedFilters.forEach((item, index) => {
                //   console.log(item.selected.length);
                this.selectedFiltersActive[index] = item.selected.length;
                if (item.selected.length > 0) {
                    dropdownActiveFilters.push(item.title);

                }
            });

            if (dropdownActiveFilters.length == 0 && !this.searchQuery) { console.log('blank_'); return this.visibleResults = this.fullDatabase }

            this.fullDatabase.forEach(post => {
                this.filters.forEach(filter => {
                    if (dropdownActiveFilters.includes(filter.title)) {
                        //   console.log(filter.title);
                        filter.options.forEach(opt => {
                            if (opt.checked) {

                                let isContentType = false;
                                let isPograms = false;
                                let isCareersStage = false;
                                let isTags = false;

                                if (post && post.content_type) {
                                    isContentType = opt.ids.some(id => post.content_type.includes(id));
                                }
                                if (post && post.programs_committees) {
                                    isPograms = opt.ids.some(id => post.programs_committees.includes(id));
                                }
                                if (post && post.career_stage) {
                                    isCareersStage = opt.ids.some(id => post.career_stage.includes(id));
                                }
                                if (post && post.tx_tags) {
                                    isTags = opt.ids.some(id => post.tx_tags.includes(id));
                                }

                                //     isRelatedCampaign = opt.ids.some(id => post.acf.related_campaigns.includes(id));
                                //     isRelatedEvent = opt.ids.some(id => post.acf.related_events.includes(id));
                                //     isRelatedResource = opt.ids.some(id => post.acf.related_resources.includes(id));

                                if (isContentType || isPograms || isCareersStage || isTags) {

                                    if (!filteredPosts.some(filteredPost => filteredPost === post)) {
                                        filteredPosts.push(post);
                                    }
                                }
                            }
                        });
                    }
                });
            });

            //////////////////////////////////////////////////////////////////////////////////////////////
            if (dropdownActiveFilters.length > 1) {

                let newFilteredPosts = []

                //     console.log('multiple triggered', selectedFilters)

                let relevantFilters = selectedFilters.filter(item => item.selected.length > 0)

                //  console.log(filteredPosts)
                //            console.log(relevantFilters)


                let bar = relevantFilters.length;
                //    console.log('the bar is', bar)
                //    console.log('===============================')
                filteredPosts.forEach(post => {
                    post.relevantScore = 0;

                    //      console.log(post.title.rendered)

                    relevantFilters.forEach(filter => {

                        let hasCommonElement = false;

                        filter.selected.forEach(sel => {
                            if (filter.title == "Career Stage") {
                                if (post.content_type.length > 0) {
                                    hasCommonElement = post.career_stage.some(element => sel.ids.includes(element));
                                    if (hasCommonElement) { post.relevantScore++; console.log('has match', 1) }
                                }
                            }
                            if (filter.title == "Programs & Committees") {
                                if (post.programs_committees.length > 0) {
                                    //    console.log(post)
                                    hasCommonElement = post.programs_committees.some(element => sel.ids.includes(element));
                                    //  console.log(post.programs_committees)
                                    //   console.log(filter.selected[0].ids)
                                    if (hasCommonElement) { post.relevantScore++; console.log('has match', 2) }
                                }
                            }
                            if (filter.title == "Content Type") {
                                if (post.content_type.length > 0) {
                                    hasCommonElement = post.content_type.some(element => sel.ids.includes(element));
                                    if (hasCommonElement) { post.relevantScore++; console.log('has match', 3) }
                                }
                            }
                            if (filter.title == "Tags") {
                                if (post.tx_tags.length > 0) {
                                    hasCommonElement = post.tx_tags.some(element => sel.ids.includes(element));
                                    if (hasCommonElement) { post.relevantScore++; console.log('has match', 4) }
                                }
                            }
                        })


                        // let concat = [...post.content_type, ...post.programs_committees, ...post.career_stage, ...post.tx_tags]
                        //  const hasCommonElement = concat.some(element => filter.selected[0].ids.includes(element));
                        //  if (hasCommonElement) { post.relevantScore++ }
                    });

                    //  console.log('>', post.relevantScore)
                    if (post.relevantScore >= bar) { newFilteredPosts.push(post) }
                })

                return this.textBarSearch(newFilteredPosts)
            }
            return this.textBarSearch(filteredPosts)
        },

        textBarSearch(filteredPosts) {
            // console.log('before text', filteredPosts)

            if (filteredPosts.length < 1 && this.selectedFiltersActive.some(value => value !== 0)) {
                return this.visibleResults = []
            }

            if (filteredPosts.length < 1) { filteredPosts = this.fullDatabase }

            if (this.searchQuery) {
                let searchTerms = this.searchQuery.toLowerCase().split(/\s+/);
                filteredPosts = filteredPosts
                    .filter(post => {
                        let title = post.title.rendered ? post.title.rendered.toLowerCase() : '';
                        let excerpt = post.acf['post-excerpt'] ? post.acf['post-excerpt'].toLowerCase() : '';

                        // Check if either title or excerpt contains any of the search terms
                        return searchTerms.some(term => title.includes(term) || excerpt.includes(term));
                    })
                    .map(post => {
                        let title = post.title.rendered ? post.title.rendered.toLowerCase() : '';
                        let excerpt = post.acf['post-excerpt'] ? post.acf['post-excerpt'].toLowerCase() : '';
                        let matchCount = searchTerms.reduce((count, term) => {
                            if (title.includes(term)) count++;
                            if (excerpt.includes(term)) count++;
                            return count;
                        }, 0);

                        return { ...post, matchCount };
                    })
                    .sort((a, b) => b.matchCount - a.matchCount); // 

            }

            //  console.log('number of results: ', filteredPosts.length)
            this.filteredResults = filteredPosts;
            //  console.log(filteredPosts)
            return this.visibleResults = filteredPosts.slice(0, this.itemsPerPage);
        },

        getTitleClass(index) {
            const positionInRow = index % 3;
            if (positionInRow === 0) return 'first-col';
            if (positionInRow === 1) return 'second-col';
            if (positionInRow === 2) return 'third-col';
        },

        getCardClass(index) {
            const positionInRow = index % 3;
            if (positionInRow === 0) return 'first-colCard';
            if (positionInRow === 1) return 'second-colCard';
            if (positionInRow === 2) return 'third-colCard';
        },

        getIconClass(index) {
            const positionInRow = index % 3;
            if (positionInRow === 0) return 'first-colIcon';
            if (positionInRow === 1) return 'second-colIcon';
            if (positionInRow === 2) return 'third-colIcon';
        },


        getHoverClass(index) {
            const positionInRow = index % 3;
            if (positionInRow === 0) return 'first-colHover';
            if (positionInRow === 1) return 'second-colHover';
            if (positionInRow === 2) return 'third-colHover';
        },

        getIconSrc(post) {
            //console.log('>>>',post.iconSrc)
            // console.log(post)
            if (post.formatType == "page") {
                //     console.log('page!')
                return 'https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png';
            }
            return post.iconSrc || this.defaultIconSrc;
        },
        getImageUrlById(imageId) {

            if (!imageId || imageId == '') {
                return this.defaultIconSrc;
            }

            return this.imageReference[imageId] || this.defaultIconSrc;;

            /*             try {
                            const response = await fetch(`/wp-json/wp/v2/media/${imageId}`);
                            if (!response.ok) {
                                console.error(`Error fetching image: Received response status ${response.status}`);
                                throw new Error(`HTTP error! status: ${response.status}`);
                            }
                            const image = await response.json();
                            this.imageUrls[imageId] = image.source_url;
                            return image.source_url;
                        } catch (error) {
                            console.error('Error fetching image:', error.message);
                            this.imageUrls[imageId] = this.defaultIconSrc;
                            return this.defaultIconSrc;
                        } */
        },

        async getAllPosts(postType, page) {
            //console.log(postType)
            try {
                const response = await fetch(`/wp-json/wp/v2/${postType}?page=${page}&per_page=100`);// https://vicdiv-dev.yarko.dev/
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const posts = await response.json();
                const totalPages = parseInt(response.headers.get('X-WP-TotalPages'));

                posts.forEach(post => {
                    if (postType == 'posts') { post.content_type = [328] }
                    post.iconSrc = this.defaultIconSrc;
                    post.formatType = "post"
                });

                this.allPosts = this.allPosts.concat(posts);

                console.log(this.allPosts)

                if (page < totalPages) {
                    return this.getAllPosts(postType, page + 1);
                }
            } catch (error) {
                console.error('Error fetching posts:', error);
            }
        },

        async getAllPages() {

            let allJobListings = [];
            const perPage = 10;
            const fields = 'id,title,excerpt,link,acf';

            const fetchJobListings = async (page = 1, totalPages = 0) => {

                try {
                    const response = await fetch(`/wp-json/wp/v2/pages?page=${page}&per_page=${perPage}&_fields=${fields}`);

                    if (!response.ok) {
                        throw new Error(`Network response was not ok for page ${page}`);
                    }

                    const contentType = response.headers.get('Content-Type');
                    if (!contentType || !contentType.includes('application/json')) {
                        console.warn(`Expected JSON response for page ${page}, but received: ${contentType}`);
                        throw new Error(`Unexpected content type for page ${page}`);
                    }

                    if (page === 1) {
                        totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10);
                    }

                    const data = await response.json();
                    allJobListings = allJobListings.concat(data);


                    if (page < totalPages) {
                        await fetchJobListings(page + 1, totalPages);
                    } else {
                        let relevantPages = [];
                        allJobListings.forEach(item => {

                            if (item.excerpt.rendered == '') { console.log('') }
                            else {
                                item.acf['post-excerpt'] = item.excerpt.rendered.slice(0, 155) + "...";
                                item.iconSrc = 'https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png'//https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png

                                item.tx_tags = item.acf.tag
                                item.content_type = item.acf.content_type
                                item.career_stage = item.acf.career_stages
                                item.programs_committees = item.acf.program_comites

                                item.formatType = "page"
                                relevantPages.push(item)
                            }
                        })
                        //  console.log('pages:', relevantPages)
                        this.allPosts = this.allPosts.concat(relevantPages);
                    }
                } catch (error) {
                    console.error('Error fetching page:', page, error);
                }
            };

            await fetchJobListings();
        },
        setCorrectIconsForPosts() {
            //set image for each post
            this.allPosts.forEach((post, index) => {

                if (post.acf && post.acf['post-icon']) {
                    post.iconSrc = this.getImageUrlById(post.acf['post-icon']);
                }
                if (post.formatType == "page") {
                    post.iconSrc = 'https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png';
                }
            });
        },
        fetchAllPosts() {
            //  console.log('promising posts...')
            Promise.all([
                //     this.getAllPosts('event', 1), // no events on vic div for now
                this.getAllPosts('initiative', 1),
                this.getAllPosts('resource', 1),
                this.getAllPosts('posts', 1),

                this.getAllPages(),
            ])
                .then(() => {
                    this.setCorrectIconsForPosts();

                    this.firstLoadDone = true;
                    this.fullDatabase = this.allPosts;
                    this.filteredResults = this.allPosts
                    this.visibleResults = this.fullDatabase.slice(0, this.itemsPerPage);
                    console.log(this.visibleResults)

                })
                .catch(error => console.error('Error fetching posts:', error));
        },

        fetchDummyDatabaseDeleteThisLater() {
            this.fullDatabase = database;

            this.allPosts = this.fullDatabase;
            this.fullDatabase.forEach((post, index) => {
                if (post.acf && post.acf['post-icon']) {
                    this.allPosts[index].iconSrc = this.getImageUrlById(post.acf['post-icon']);
                }
                if (post.formatType == "page") {
                    this.allPosts[index].iconSrc = 'https://vancouverdivision.com/wp-content/uploads/2022/08/Pages-Icon-01.png';
                }
            });
            this.fullDatabase = this.allPosts;
            this.filteredResults = this.allPosts
            this.visibleResults = this.fullDatabase.slice(0, this.itemsPerPage);
            this.firstLoadDone = true
            //   console.log(this.fullDatabase)
        },

        toggleDropdown(index) {
            this.filters.forEach((filter, i) => {
                if (i !== index) filter.show = false;
            });
            this.filters[index].show = !this.filters[index].show;
        },
        closeDropdowns() {
            this.filters.forEach(filter => {
                filter.show = false;
            });
        },
        clearFilters() {
            //  console.log('clear');

            this.filters.forEach(filter => {
                filter.options.forEach(option => {
                    option.checked = false;
                })
            });

            this.applySearch();

        }
    },

    computed: {
        computedIconSrc(post) {
            //    console.log(post)
            return post.iconSrc || 'https://vancouverdivision.com/wp-content/uploads/2022/05/6-Tools.png';
        },
        paginatedResults() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.visibleResults.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.visibleResults.length / this.itemsPerPage);
        }
    },

    mounted() {



       //this.fetchDummyDatabaseDeleteThisLater()

       this.fetchAllPosts();
       console.log("console test")

    },
    directives: {
        clickOutside: {
            bind(el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    if (!(el == event.target || el.contains(event.target))) {
                        vnode.context[binding.expression](event);
                    }
                };
                document.addEventListener('click', el.clickOutsideEvent);
            },
            unbind(el) {
                document.removeEventListener('click', el.clickOutsideEvent);
            },
        },
    }




};
</script>
  
  
<style>
.vueContainer {
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
}

.filter-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.search-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;
}

.search-row input {
    border-radius: 0px;
    border-color: #cccc;
}

.search-row button {
    border-radius: 0px;
    transition: 0.5s;
    margin-left: 5px;
    border: 1px solid #006D8A;
    background: #428da1 !important;
    color: #fff !important;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border-radius: 4px;
}

.search-row button:hover {
    background-color: #CD6C33;
    border-color: #CD6C33;
}

.filters-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    WIDTH: 100%;
}

.filter-column {
    margin-bottom: 20px;
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: start;
}

.filter-title {
    text-align: left;
    margin-bottom: 5px;
    margin-top: 10px;

    color: #333;
    font-family: "Robotos Slab", Sans-serif;
    font-size: 17px;
    font-weight: 400;
    text-wrap: nowrap;
}

.dropdown-button {
    border: 1px solid #006D8A;
    display: flex;
    text-align: left;
    width: 100%;
    cursor: pointer;
    position: relative;
    transition: 0.5s;
    align-content: center;
    justify-content: flex-start;
    align-items: center;

    background: #428da1 !important;
    color: #fff !important;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border-radius: 4px;
    transition: all .3s;
    flex-wrap: nowrap;
}

.resetFilterButtonContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.resetFilterButon {
    border: 1px solid #006D8A;
    display: flex;
    text-align: left;
    width: 120px;
    cursor: pointer;
    position: relative;
    transition: 0.5s;
    align-content: center;
    justify-content: flex-start;
    align-items: center;

    background: #428da1 !important;
    color: #fff !important;
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border-radius: 4px;
    transition: all .3s;
    flex-wrap: nowrap;
}

.dropdown-button:hover {
    border: 1px solid #CD6C33;
    background-color: #f9f9f9;
    color: #006D8A;

}

.dropdown-button .arrow {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    display: none;
}

.checkbox-dropdown {
    display: none;
    border: 1px solid #ccc;
    position: absolute;
    background-color: #fff;
    width: 100%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    z-index: 10;
}

.checkbox-dropdown.show {
    display: flex;
    flex-direction: column;
    width: 200px;
    margin-top: 79px;
}

.checkbox-option {
    padding: 10px 16px;
    display: flex;
    align-items: center;
}

.checkbox-option:last-child {
    border-bottom: none;
}

.checkbox-option input[type="checkbox"] {
    margin-right: 8px;
}

.checkbox-option label {
    font-family: "Barlow", Sans-serif;
    font-weight: 500;
    color: #006D8A;
}

.apply-button {
    padding: 10px 16px;
    background-color: #006D8A;
    color: white;
    border: none;
    border-radius: 0px;
    cursor: pointer;
    margin-top: 10px;
    align-self: end;
    transition: 0.5s;
}

.apply-button:hover {
    background-color: #CD6C33;
}

@media (max-width: 768px) {
    .filters-row {
        flex-direction: column;
    }

    .filter-column {
        margin-bottom: 0px
    }

    .filter-column,
    .search-row {
        width: 100%;
    }

    .checkbox-dropdown.show {
        width: 90vw;
    }

    .resetFilterButtonContainer {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 25px;
    }

}


/**************************************************************************************** */

.results-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: space-between;
    margin-top: 20px;
    width: 100%;
}

.result-card {
    display: flex;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 16px;
    background: #fff;
    overflow: hidden;
    text-align: center;
    height: 390px;
    width: 270px !important;
    flex-direction: column;
    position: relative;
    border-radius: 8px;
}

.hover-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 30px;
    color: #FFFFFF;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    pointer-events: none;
}

.result-card:hover .hover-overlay {
    opacity: 1;
}

.hover-title {
    transition: opacity 0.3s ease;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 26px;
    color: white;
}

.result-icon {
    background-color: #009688;
    padding: 20px;
    border-radius: 50%;

    width: 150px !important;
    min-height: 150px !important;

    height: 150px !important;
    border-radius: 50%;
    margin: 16px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: visible;
}

.imgIconResult {
    width: 120px;
}

.result-summary {
    font-size: 14px;
    color: #666;
    padding: 0 16px;
    margin-top: 8px;
    margin-bottom: 8px;
    height: 135px;
    text-align: left;
}

.result-title {
    color: white;
    padding: 5px;
    font-size: 17px;
    font-weight: bold;
    height: 95px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 0;
}

.first-colCard {
    border: 1px solid #006D8A;
}

.second-colCard {
    border: 1px solid #BBBF9A;
}

.third-colCard {
    border: 1px solid #E48F5B;
}

.first-col {
    background-color: #006D8A;
}

.second-col {
    background-color: #BBBF9A;
}

.third-col {
    background-color: #E48F5B;
}

.first-colIcon {
    background-color: #006D8A;
}

.second-colIcon {
    background-color: #BBBF9A;
}

.third-colIcon {
    background-color: #E48F5B;
}

.first-colHover {
    background-color: #006D8A;
}

.second-colHover {
    background-color: #BBBF9A;
}

.third-colHover {
    background-color: #E48F5B;
}

@media (max-width: 768px) {
    .result-card {
        flex-basis: 100%;
    }
}

.NofFilter {
    background-color: #006D8A;
    padding: 9px;
    margin-right: 5px;
    border-radius: 50%;
    color: white;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
}

.pagination-controls {
    display: flex;
    justify-content: center;
    align-items: center;
}

.pagination-controls span {
    margin: 15px;
}

/** ******************************** */

.loaderContainer {
    display: flex;
    justify-content: center;
    width: 100%;
}

.loader {
    border: 10px solid #f3f3f3;
    border-top: 10px solid #006D8A;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 2s linear infinite;
    margin-top: 50px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>



  
  


// WEBPACK FOOTER //
// src/allResources.vue